import React from 'react';

/* Iconos lineales propios (peso ~1.6), en vez de una librería genérica
   tipo Lucide — para la skill minimalist-ui. */

type IconProps = { size?: number; className?: string };

const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
});

export const MnChatIcon: React.FC<IconProps> = ({ size = 22, className }) => (
  <svg {...base(size)} className={className}>
    <path d="M4 5.5h16v10.5H9.5L5.5 19v-3H4z" />
    <path d="M8 9.5h8M8 12.5h5" />
  </svg>
);

export const MnSparkleIcon: React.FC<IconProps> = ({ size = 22, className }) => (
  <svg {...base(size)} className={className}>
    <path d="M12 3.5 13.4 9 19 10.5 13.4 12 12 17.5 10.6 12 5 10.5 10.6 9z" />
    <path d="M19 3.5v3M17.5 5h3" />
  </svg>
);

export const MnCalendarIcon: React.FC<IconProps> = ({ size = 22, className }) => (
  <svg {...base(size)} className={className}>
    <rect x="4" y="5.5" width="16" height="14" rx="2" />
    <path d="M4 10h16M8 3.5v3M16 3.5v3" />
  </svg>
);

export const MnClockIcon: React.FC<IconProps> = ({ size = 22, className }) => (
  <svg {...base(size)} className={className}>
    <circle cx="12" cy="12.5" r="8" />
    <path d="M12 8v4.5l3 2" />
  </svg>
);

export const MnChartIcon: React.FC<IconProps> = ({ size = 22, className }) => (
  <svg {...base(size)} className={className}>
    <path d="M5 19V10M12 19V5M19 19v-6" />
    <path d="M4 19.5h16" />
  </svg>
);

export const MnBuildingIcon: React.FC<IconProps> = ({ size = 22, className }) => (
  <svg {...base(size)} className={className}>
    <rect x="5" y="4" width="9" height="16" rx="1" />
    <rect x="14" y="9" width="5" height="11" rx="1" />
    <path d="M8 8h.01M11 8h.01M8 11.5h.01M11 11.5h.01M8 15h.01M11 15h.01" />
  </svg>
);

export const MnArrowUpRightIcon: React.FC<IconProps> = ({ size = 18, className }) => (
  <svg {...base(size)} className={className}>
    <path d="M7 17 17 7M9 7h8v8" />
  </svg>
);

export const MnCheckIcon: React.FC<IconProps> = ({ size = 18, className }) => (
  <svg {...base(size)} className={className}>
    <path d="M5 12.5 9.5 17 19 7" />
  </svg>
);
